/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-08-26 11:37:49
 * @LastEditors: tangshuo
 * @LastEditTime: 2022-11-01 14:26:04
 */
import React from 'react';
import { Icon, Tooltip } from '@firesoon/antd';
import classNames from 'classnames';
import { IInfoTip } from './interface';
import './index.less';

const Index = ({ title = '', text = '', isStrong = false, size = 12, ghost = false, tooltipProps = {} }: IInfoTip) => {
  return (
    <div>
      <span style={{ fontSize: size }} className={classNames({ 'fs-info-tip-ghost': ghost })}>
        {text != null && <span style={{ marginRight: 4 }}>{text}</span>}
        <Tooltip title={title} {...tooltipProps}>
          {isStrong ? (
            <Icon className="fs-info-tip-icon" type="exclamation-circle" theme="filled" />
          ) : (
            <Icon className="fs-info-tip-icon" type="info-circle" />
          )}
        </Tooltip>
      </span>
    </div>
  );
};

export default Index;
